// 使用者 session composable。狀態宣告在模組層級，故為全 App 共用的單例；
// useSession() 回傳問答區顯示、使用者資料、操作權限等共用響應式狀態的存取器。
import { reactive, ref } from 'vue';
import { getCookie } from '../utils/cookie';

// 正常情況問答區預設顯示，若有遇到錯誤，則隱藏問答區並且顯示錯誤訊息
const qaAreaShow = ref(true);
const handleQANoShow = () => {
  qaAreaShow.value = false;
};

const userData = reactive({
  teachable_id: '',
  email: '',
});

// 確認可發問、按讚、回答的狀態：綁定 rpg 且目前的 token 是 rpg
const actionPermission = ref(false);
const checkActionPermission = () => { // true: 可以操作，false: 不可操作
  const tokenType = getCookie('rpg_temp_token_type');
  const isLink = getCookie('rpg_temp_token_is_link');
  const token = getCookie('rpg_temp_token');
  if (tokenType === 'rpg' && isLink === 'true' && token) {
    actionPermission.value = true;
  } else {
    actionPermission.value = false; // 先修改為 true，之後再改回 false
  }
};

export function useSession() {
  return {
    qaAreaShow,
    handleQANoShow,
    userData,
    actionPermission,
    checkActionPermission,
  };
}
